import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class BackToDashboardService {
  disable = true;
}
